/*
  React Component named "TaskCard" which renders a card for Task
*/

const TaskCard = ({ id, onDrag, taskName, isDark }) => {
  return (
    <div
      className={`task-card ${isDark ? "task-card-dark" : ""}`}
      id={id}
      draggable="true"
      onDragStart={onDrag}
    >
      <p>{taskName}</p>
    </div>
  );
};

export default TaskCard;
